// CHANGES TO THIS FILE MAY CAUSE INCORRECT BEHAVIOR AND WILL BE LOST IF THE CODE IS REGENERATED
// auto-generated on 6/27/2024 10:11:44 AM by John Caccavaro's (caccavaro123@gmail.com) Frameworks tool.

/* eslint-disable @typescript-eslint/no-empty-interface */

import { ConnectionStatusTypeEnum } from '@wagepoint/ui-shared-library/shared-system/services/appCore/models/schema/Schema';
import { WorkflowResponseInterface } from '@wagepoint/ui-shared-library/shared-system/services/finance/models/functions/Functions';
import { CultureTypeEnum } from '@wagepoint/ui-shared-library/shared-system/services/ui-config-access/uiConfigAccess.contracts';
import { Post } from 'services/httpClient';
import { PayPeriodDocumentTypeEnum } from 'services/payroll-report-access/payrollReport.contracts';
import { AccountingSyncStatusTypeEnum } from 'services/payroll/schema/Schema';
import { DepartmentInterface } from 'services/payroll/Functions/Functions';
import { ReportTypeEnum } from 'services/appCore/models/schema/Schema';

export enum GetVendorListEnum {
  companyIdRequired = 0,
}

export enum PersistVendorEnum {
  companyIdRequired = 0,
  vendorNameRequired = 1,
}

export enum GetAccountsEnum {
  companyIdRequired = 0,
}

export enum ConnectEnum {
  companyIdRequired = 0,
  realmIdRequired = 1,
  connectionStatusRequired = 2,
}

export enum GetInitialStateEnum {
  companyIdRequired = 0,
}

export enum GetAccountListsEnum {
  companyIdRequired = 0,
}

export enum GetMissingAccountsEnum {
  companyIdRequired = 0,
}

export enum CreateMissingAccountsEnum {
  companyIdRequired = 0,
  accountNamesRequired = 1,
}

export enum ProcessAutoSyncEnum {
  workflowInstancekeyRequired = 0,
}

export enum DisconnectEnum {
  companyIdRequired = 0,
}

export enum IntegrationTypeEnum {
  qbo = 0,
  xero = 1,
  fresh = 2,
}

export enum ProcessTokenRefreshEnum {
  workflowInstancekeyRequired = 0,
}

export interface GetVendorListRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetVendorListResponseInterface {
  vendorList: Array<VendorInterface>;
  validationResults: ValidationResultsInterface;
}

export interface VendorInterface {
  id: string;
  name: string;
}

export interface PersistVendorRequestInterface {
  companyId: number;
  vendorName: string;
  integrationType: IntegrationTypeEnum;
}

export interface PersistVendorResponseInterface {
  vendor: VendorInterface;
  validationResults: ValidationResultsInterface;
  validationResultList?: Array<ValidationResultInterface>;
}

export interface GetMappingInitialStateRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetMappingInitialStateResponseInterface {
  departmentList: Array<DepartmentInterface>;
  validationResults: ValidationResultsInterface;
}

export interface SecurityContextInterface {
  accessToken: string;
  refreshToken: string;
  realmId: string;
  baseUrl: string;
  minorVersion: string;
  isAccessTokenExpired: boolean;
  isRefreshTokenExpired: boolean;
}

export interface ConnectRequestInterface {
  authorizationCode: string;
  companyId: number;
  connectionStatus: ConnectionStatusTypeEnum;
  cultureType: CultureTypeEnum;
  realmId: string;
  redirectUrl: string;
  integrationType: IntegrationTypeEnum;
}

export interface ConnectResponseInterface {
  displayWarningMessage: boolean;
  validationResults: ValidationResultsInterface;
}

export interface GetInitialStateRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetInitialStateResponseInterface {
  isVendorLinked: boolean;
  connectionStatus: ConnectionStatusTypeEnum;
  isChartOfAccountsMapped: boolean;
  authorizationUri: string;
  accountingSyncStatus: AccountingSyncStatusTypeEnum;
  accountingSyncErrorMessage: string;
  isActive: boolean;
  organizationName: string;
  validationResults: ValidationResultsInterface;
}

export interface ExportPayrollRequestInterface {
  companyId: number;
  payPeriodId: number;
  payGroupId: number;
  subscriptionMonth?: number;
  subscriptionYear?: number;
  payPeriodDocumentList: Array<PayPeriodDocumentInterface>;
  integrationType: IntegrationTypeEnum;
  invoiceId: number;
  invoiceList: Array<InvoiceInterface>;
}

export interface ExportPayrollResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface AutoSyncPreferenceInterface {
  id: number;
  autoSync: boolean;
  effectiveDate: string;
  autoSyncAttachmentList: Array<AutoSyncAttachmentInterface>;
}

export interface AttachmentInterface {
  payPeriodDocumentType: PayPeriodDocumentTypeEnum;
}

export interface AutoSyncAttachmentInterface {
  reportType: ReportTypeEnum;
  attachPostingJournal: boolean;
  attachPayrollRegister: boolean;
  attachPayrollTaxes: boolean;
  attachInvoice: boolean;
}

export interface InvoiceInterface {
  name: string;
  attachPostingJournal: boolean;
  attachPayrollRegister: boolean;
  attachInvoice: boolean;
  attachParollTaxes: boolean;
}

export interface GetAccountListRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetAccountListResponseInterface {
  accountList: Array<AccountInterface>;
  validationResults: ValidationResultsInterface;
}

export interface AccountInterface {
  id: number;
  name: string;
  isBankAccount: boolean;
  idString: string;
}

export interface GetMissingAccountsRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetMissingAccountsResponseInterface {
  accountNames: Array<string>;
  validationResults: ValidationResultsInterface;
}

export interface CreateMissingAccountsRequestInterface {
  companyId: number;
  accountNames: Array<string>;
  integrationType: IntegrationTypeEnum;
}

export interface CreateMissingAccountsResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ProcessAutoSyncRequestInterface {
  workflowInstanceKey?: string;
  integrationType: IntegrationTypeEnum;
}

export interface ProcessAutoSyncResponseInterface {
  workflowResponse?: WorkflowResponseInterface;
  validationResults: ValidationResultsInterface;
}

export interface DisconnectRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface DisconnectResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface GetTaxListRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetTaxListResponseInterface {
  taxList: Array<TaxInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TaxInterface {
  id: string;
  name: string;
}

export interface PayPeriodDocumentInterface {
  documentId: number;
  payPeriodDocumentType: PayPeriodDocumentTypeEnum;
}

export interface GetDefaultMappingRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetDefaultMappingResponseInterface {
  accountList: Array<AccountInterface>;
  validationResults: ValidationResultsInterface;
}

export interface RenewTokenRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface RenewTokenResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface ProcessTokenRefreshRequestInterface {
  workflowInstanceKey?: string;
}

export interface ProcessTokenRefreshResponseInterface {
  workflowResponse?: WorkflowResponseInterface;
  validationResults: ValidationResultsInterface;
}

export interface GetErrorMessagesRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
  isAutoSync: boolean;
}

export interface GetErrorMessagesResponseInterface {
  messageList: Array<MessageInterface>;
  validationResults: ValidationResultsInterface;
}

export interface AcknowledgeMessageRequestInterface {
  messageList: Array<MessageInterface>;
}

export interface AcknowledgeMessageResponseInterface {
  validationResults: ValidationResultsInterface;
}

export interface MessageInterface {
  id: number;
  description: string;
}

export interface GetTrackingCategoriesListRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetTrackingCategoriesListResponseInterface {
  trackingCategoryList: Array<TrackingCategoryInterface>;
  validationResults: ValidationResultsInterface;
}

export interface TrackingCategoryInterface {
  id: string;
  name: string;
  trackingCategoryOptionList: Array<TrackingCategoryOptionInterface>;
}

export interface TrackingCategoryOptionInterface {
  id: string;
  name: string;
}

export interface GetTrackingCategoryMapRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface GetTrackingCategoryMapResponseInterface {
  trackingCategoryId: string;
  departmentOptionMapList: Array<DepartmentOptionMapInterface>;
  validationResults: ValidationResultsInterface;
}

export interface DepartmentOptionMapInterface {
  departmentId: number;
  departmentName: string;
  trackingCategoryOptionId: string;
  trackingCategoryOptionName: string;
}

export interface CreateTrackingCategoriesRequestInterface {
  companyId: number;
  integrationType: IntegrationTypeEnum;
}

export interface CreateTrackingCategoriesResponseInterface {
  trackingCategoryId: string;
  departmentOptionMapList: Array<DepartmentOptionMapInterface>;
  validationResults: ValidationResultsInterface;
}

export enum ValidationSeverityEnum {
  NotDefined = 0,
  Passed,
  Information,
  Warning,
  Error,
}

export interface ValidationResultInterface {
  validationSeverityEnum: ValidationSeverityEnum;
  validationMessage: string;
  exceptionInformation: string;
  validationCode: number;
  validationTag: string;
  isValid: boolean;
}

export interface ValidationResultsInterface {
  validationResultList?: Array<ValidationResultInterface>;
}

export interface AutoDisconnectRequestInterface {
  companyId?: number;
  workflowInstanceKey?: string;
}

export interface AutoDisconnectResponseInterface {
  workflowResponse?: WorkflowResponseInterface;
  validationResults: ValidationResultsInterface;
}

export class AccountingManagerService {
  getVendorList(request: GetVendorListRequestInterface): Promise<GetVendorListResponseInterface> {
    return Post('/PayrollAccountingManager/getVendorList', request);
  }

  persistVendor(request: PersistVendorRequestInterface): Promise<PersistVendorResponseInterface> {
    return Post('/PayrollAccountingManager/persistVendor', request);
  }

  getMappingInitialState(
    request: GetMappingInitialStateRequestInterface
  ): Promise<GetMappingInitialStateResponseInterface> {
    return Post('/PayrollAccountingManager/getMappingInitialState', request);
  }

  connect(request: ConnectRequestInterface): Promise<ConnectResponseInterface> {
    return Post('/PayrollAccountingManager/connect', request);
  }

  getInitialState(request: GetInitialStateRequestInterface): Promise<GetInitialStateResponseInterface> {
    return Post('/PayrollAccountingManager/getInitialState', request);
  }

  exportPayroll(request: ExportPayrollRequestInterface): Promise<ExportPayrollResponseInterface> {
    return Post('/PayrollAccountingManager/exportPayroll', request);
  }

  getAccountList(request: GetAccountListRequestInterface): Promise<GetAccountListResponseInterface> {
    return Post('/PayrollAccountingManager/getAccountList', request);
  }

  getMissingAccounts(request: GetMissingAccountsRequestInterface): Promise<GetMissingAccountsResponseInterface> {
    return Post('/PayrollAccountingManager/getMissingAccounts', request);
  }

  createMissingAccounts(
    request: CreateMissingAccountsRequestInterface
  ): Promise<CreateMissingAccountsResponseInterface> {
    return Post('/PayrollAccountingManager/createMissingAccounts', request);
  }

  processAutoSync(request: ProcessAutoSyncRequestInterface): Promise<ProcessAutoSyncResponseInterface> {
    return Post('/PayrollAccountingManager/processAutoSync', request);
  }

  disconnect(request: DisconnectRequestInterface): Promise<DisconnectResponseInterface> {
    return Post('/PayrollAccountingManager/disconnect', request);
  }

  getTaxList(request: GetTaxListRequestInterface): Promise<GetTaxListResponseInterface> {
    return Post('/PayrollAccountingManager/getTaxList', request);
  }

  getDefaultMapping(request: GetDefaultMappingRequestInterface): Promise<GetDefaultMappingResponseInterface> {
    return Post('/PayrollAccountingManager/getDefaultMapping', request);
  }

  renewToken(request: RenewTokenRequestInterface): Promise<RenewTokenResponseInterface> {
    return Post('/PayrollAccountingManager/renewToken', request);
  }

  processTokenRefresh(request: ProcessTokenRefreshRequestInterface): Promise<ProcessTokenRefreshResponseInterface> {
    return Post('/PayrollAccountingManager/processTokenRefresh', request);
  }

  getErrorMessages(request: GetErrorMessagesRequestInterface): Promise<GetErrorMessagesResponseInterface> {
    return Post('/PayrollAccountingManager/getErrorMessages', request);
  }

  acknowledgeMessage(request: AcknowledgeMessageRequestInterface): Promise<AcknowledgeMessageResponseInterface> {
    return Post('/PayrollAccountingManager/acknowledgeMessage', request);
  }

  getTrackingCategoriesList(
    request: GetTrackingCategoriesListRequestInterface
  ): Promise<GetTrackingCategoriesListResponseInterface> {
    return Post('/PayrollAccountingManager/getTrackingCategoriesList', request);
  }

  getTrackingCategoryMap(
    request: GetTrackingCategoryMapRequestInterface
  ): Promise<GetTrackingCategoryMapResponseInterface> {
    return Post('/PayrollAccountingManager/getTrackingCategoryMap', request);
  }

  createTrackingCategories(
    request: CreateTrackingCategoriesRequestInterface
  ): Promise<CreateTrackingCategoriesResponseInterface> {
    return Post('/PayrollAccountingManager/createTrackingCategories', request);
  }

  autoDisconnect(request: AutoDisconnectRequestInterface): Promise<AutoDisconnectResponseInterface> {
    return Post('/PayrollAccountingManager/autoDisconnect', request);
  }
}

export default new AccountingManagerService();
